<template>
  <div>
    <generate-qr-code
      :isPopupActive="showGenerate"
      :closeCallback="closeCallback"
    />
    <connect-tokens-popup
      :isPopupActive="showTokens"
      :closeCallback="closeCallback"
    />
    <chosen-instance-pop-up
      title="Conexões Desconectadas"
      :is-active="showChosen"
      :activeInstances="disconnected"
      :is-read-only="true"
      :is-multiple="false"
      :only-allowed="true"
      :is-allowed-connect="true"
      @close="showChosen = false"
    />

    <vs-popup ref="popup-satus-cropper" class="chat-upload-image-popup" title="Vantagens da API Cloud" :active.sync="activePopupAlert" @close="closePopupAlert()">
      <div class="w-full">
        <img :src="require('@/assets/images/brands/new_CTA_Cloud.gif')" class="w-full" style="border: 2px solid #CCCCCC;"/>
      </div>
      <strong style="font-size: 20px; margin-left: 10px; margin-top: 50px;">Entre em Contato Conosco</strong>
      <br>
      <ul style="list-style: none; padding: 0; display: flex; align-items: center; list-style-type: disc;  padding-left: 15px;">
        <li style="display: flex; align-items: center;">
          Vendas: (14) 99129-5361
          <a href="https://wa.me/5514991295361" target="_blank"><img style="cursor: pointer;" :src="require('@/assets/images/brands/whatsapp.png')" width="40" height="40"/></a>
        </li>
      </ul>
      <ul>
        <li style="padding-left: 15px;">
          Conheça mais sobre a API Cloud<a href="https://www.pedbot-faq.net/post/conhecendo-a-api-cloud" target="_blank"><strong> Click aqui</strong></a>
        </li>
      </ul>
    </vs-popup>

    <div v-if="!isOfficial && !disconnected.length && closeAlert && (dashBeta || typeConnection === 'tenancy.low-1')" @click="activeAlertPreview">
      <div class="mb-5 cursor-pointer" style="background-color: #EAF9F1; height: 148px;">
        <div style="margin: 8px; display: flex; align-items: center;">
          <div style="cursor: pointer;" class="absolute right-0 p-2" @click.prevent="closeAlertListContact">
            <feather-icon icon="XIcon" svgClasses="h-6 w-6" />
          </div>
          <feather-icon style="margin-right: 10px;" class="text-success cursor-pointer " icon="AlertTriangleIcon"/>
          <strong style="margin: 2.5px;">Mantenha Seu WhatsApp Seguro com a Cloud</strong>
        </div>
        <div class="text ml-4">
          <p style="font-size: 12px;">Experimente a integração cloud oficial do WhatsApp e desfrute de benefícios como segurança aprimorada, proteção contra banimentos inesperados, conexão estável, suporte direto da Meta e maior eficiência no seu atendimento ao cliente. <strong><a style="color: #28C76F;">Clique aqui para saber mais.</a></strong></p>
        </div>
      </div>
    </div>

    <div v-if="disconnected.length && unifyConnections && instances.length > 1" class="warning cursor-pointer">
      <div class="body" @click="showChosen = true">
        <div>
          <span class="material-icons">wifi_off</span>
        </div>
        <div class="text ml-3">
          <strong>Há {{ disconnected.length }} conexões desconectadas!</strong><br>
          <small>Clique aqui para ver mais detalhes</small>
        </div>
      </div>
    </div>

    <div v-else-if="!unifyConnections || instances.length === 1" v-for="instance in instances" :key="instance.id">
      <div v-if="instance && !instance.activated" class="warning cursor-pointer">
        <div v-if="!instance.is_official" class="body" @click="openPopup('generate', instance)">
          <div>
            <span class="material-icons">wifi_off</span>
          </div>
          <div class="text ml-3">
            <strong>Conexão {{instance.nickname||instance.name}} desconectada!</strong><br>
            <small>Clique aqui para gerar um <strong>novo QRCODE</strong></small>
          </div>
        </div>
        <div v-else-if="instance.is_official && !instance.integration_id" class="body" @click="openPopup('tokens', instance)">
          <div>
            <span class="material-icons">wifi_off</span>
          </div>
          <div class="text ml-3">
            <strong>Conexão {{instance.nickname||instance.name}} desconectada!</strong><br>
            <small>Clique aqui para adicionar as credenciais de autenticação</small>
          </div>
        </div>
        <div v-else class="body" @click="redirectToInstance(instance.id)">
          <div>
            <span class="material-icons">wifi_off</span>
          </div>
          <div class="text ml-3">
            <strong>Conexão {{instance.nickname||instance.name}} desconectada!</strong><br>
            <small>Clique aqui e será aberto nova guia onde poderá seguir as etapas de integração</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {formatRouteTenantPath, getCurrentTenant} from '@/utils'
import GenerateQrCode from '../instances/GenerateQrCode.vue'
import moduleInstance from '@/store/instance/moduleInstance'
import ChosenInstancePopUp from "@/views/instances/ChosenInstancePopUp.vue";
import ConnectTokensPopup from "@/views/instances/ConnectTokensPopup.vue";
import { dashBetas } from '@/supports/betaNotificationSupport'

export default {
  components: {ConnectTokensPopup, ChosenInstancePopUp, GenerateQrCode },
  props: {},
  data() {
    return {
      showTokens:false,
      showChosen: false,
      showGenerate: false,
      activePopupAlert: false,
      isOfficial: false,
      databaseConection: '',
      dashBeta: false,
      closeAlert: true,
      typeConnection: ''
    }
  },
  computed: {
    instances(){
      return this.$store.getters["instance/chosenInstances"];
    },
    disconnected(){
      return (this.instances.filter(instances => instances && !instances.activated)) || []
    },
    unifyConnections(){
      return this.$store.state.settings.settings.unify_connections !== undefined && !!parseInt(this.$store.state.settings.settings.unify_connections);
    }
  },
  methods: {
    closePopupAlert(){
      this.activePopupAlert = false;
    },
    closeAlertListContact(){
      this.closeAlert = false
      this.$emit('closeAlert', false)
    },
    activeAlertPreview(){
      this.activePopupAlert = true
    },
    openPopup(view, instance){
      this.$store.dispatch("instance/chooseInstanceObject", instance)
      if (view === 'tokens')        this.showTokens = true
      else if (view === 'generate') this.showGenerate = true
    },
    closeCallback() {
      this.showTokens = false
      this.showGenerate = false
    },
    redirectToInstance(id) {
      window.open(this.$router.resolve(formatRouteTenantPath(`/instances/build/${id}`)).href, '_blank');
    }
  },
  mounted(){
    const tenant = getCurrentTenant();
    this.dashBeta = dashBetas.includes(tenant);
    this.typeConnection = localStorage.getItem('connectionDatabase');;
  },
  created() {
    this.$events.on('closeAllPopUps', this.closePopupAlert);
    this.isOfficial = this.$store.state.instance.chosenInstances[0].is_official
    if (!moduleInstance.isRegistered) {
      this.$store.registerModule('instance', moduleInstance)
      moduleInstance.isRegistered = true
    }
  },
  beforeDestroy() {
    this.$events.$off('closeAllPopUps', this.closePopupAlert);
  }
}
</script>

<style lang="scss" scoped>
.warning {
  background: #FBDD6B;
  width: 100%;
  margin-bottom: 1em;

  .body {
    display: flex;
    padding: 0.5em;

    .text {
      text-align: center;
      margin-top: 1em;
    }
  }

  .material-icons {
    font-size: 5em;
    color: white
  }
}
</style>
